import React from 'react'
import NavigationLayout from 'layouts/Navigation'
import Layout from './layouts'
export default (): React.ReactElement<React.ComponentProps<any>, any> => (
  <NavigationLayout dataApp='artdetail'>
    <Layout />
  </NavigationLayout>
)